import * as URLConfig from "@frameworks/web/config/domain";
var config = URLConfig.config;
var appReport = "app-report/";
var login = "login/";
var market = "market/";
var postLoginUrl = {
    positions: config.jmwedel + config.equity + "positions/net/interop",
    positionsCom: config.jmwedel + config.commodity + "positions",
    saveIndices: config.jmwedel + config.equity + "client-details/save-indices",
    portfolioComposition: config.jmwedel +
        config.reportBase +
        appReport +
        login +
        "dashboard/sector-wise",
    contribution: config.jmwedel +
        config.reportBase +
        appReport +
        login +
        "dashboard/contribution",
    indexList: config.jmwedel + config.equity + "client-details",
    marketMapPostLogin: config.jmwedel + config.reportBase + appReport + market + "map",
    serviceList: config.jmwedel + config.jmw_login + "sr/servicelist",
    exploreTrade: config.jmwedel +
        config.revamp +
        config.jmw_eq +
        "client-details/disable-explore-trade",
    diversifyPortfolio: config.jmwedel +
        config.reportBase +
        appReport +
        login +
        "dashboard/diversify-portfolio",
    upcomingEvents: config.jmwedel + config.reportBase + appReport + login + "dashboard/events",
    allIndicesList: config.jmwedel + config.jmw_content + "indexlist/bull",
    nfoLive: config.jmwedel + config.jmw_content + "nfo/live",
};
export default postLoginUrl;
